import React, { useEffect, useRef } from "react";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import { NewNavbar } from "../Pages/NewNavbar";
import Footer from "../Footer";
import hutImg from "../../../assets/image/hut-image.png";
import hutImg1 from "../../../assets/image/hut-image1.png";
import ex1 from "../../../assets/image/ex1.png";
import ex2 from "../../../assets/image/ex2.png";
import ex3 from "../../../assets/image/ex3.png";
import stepsgif from "../../../assets/image/sell_process_steps-slow.gif";
import Slider from "react-slick";

// gsap.registerPlugin(ScrollTrigger);

const cardPositions = [
  { x: -100, y: -100 }, // top left
  { x: 100, y: -100 }, // top right
  { x: -100, y: 0 }, // mid left
  { x: 100, y: 0 }, // mid right
  { x: 100, y: 100 }, // bottom right
];

const arrowPaths = [
  { x: -100, y: -130, rotation: 0 },
  { x: 100, y: -130, rotation: 45 },
  { x: -100, y: -30, rotation: 90 },
  { x: 100, y: -30, rotation: 135 },
  { x: 100, y: 70, rotation: 180 },
];

export default function OurProcess() {
  const containerRef = useRef(null);
  const cardsRef = useRef([]);
  const arrowRef = useRef(null);

  // useEffect(() => {
  //   const cards = cardsRef.current;
  //   const arrow = arrowRef.current;

  //   // Initial states
  //   gsap.set(cards, {
  //     autoAlpha: 0,
  //     x: (i) => cardPositions[i].x,
  //     y: (i) => cardPositions[i].y,
  //   });
  //   gsap.set(arrow, {
  //     autoAlpha: 1,
  //     x: arrowPaths[0].x,
  //     y: arrowPaths[0].y,
  //     rotation: arrowPaths[0].rotation,
  //     filter: "drop-shadow(0 0 10px #00ffff)",
  //   });

  //   const tl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: containerRef.current,
  //       start: "top top",
  //       end: "+=500%",
  //       scrub: true,
  //       pin: true,
  //     },
  //   });

  //   // Animate cards and arrow in sequence
  //   cards.forEach((card, i) => {
  //     tl.to(card, { x: 0, y: 0, autoAlpha: 1, duration: 1 }, i * 1)
  //       .to(
  //         arrow,
  //         {
  //           x: arrowPaths[i].x,
  //           y: arrowPaths[i].y,
  //           rotation: arrowPaths[i].rotation,
  //           filter: "drop-shadow(0 0 20px #00ffff)",
  //           duration: 0.5,
  //           ease: "power1.inOut",
  //         },
  //         i * 0.5
  //       )
  //       .to(
  //         arrow,
  //         {
  //           filter: "drop-shadow(0 0 10px #00ffff)",
  //           duration: 0.5,
  //           ease: "power1.inOut",
  //         },
  //         i * 0.5 + 0.5
  //       );
  //   });

  //   return () => {
  //     // ScrollTrigger.kill();
  //     tl.kill();
  //   };
  // }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    loop: true,
    items: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <NewNavbar />
      {/* Our process banner section start */}
      <section className="our-process-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="main-heading">
                Our <span className="mask-text">M</span> Process
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Our process banner section end */}
      {/* <section
        ref={containerRef}
        style={{
          height: "100vh",
          position: "relative",
          overflow: "hidden",
          background: "#1a1a1a",
        }}
      >
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            ref={(el) => (cardsRef.current[i] = el)}
            style={{
              width: 150,
              height: 150,
              backgroundColor: "#3498db",
              position: "absolute",
              borderRadius: 10,
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 20,
              fontWeight: "bold",
              userSelect: "none",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
            }}
          >
            Card {i + 1}
          </div>
        ))}

       
        <svg
          ref={arrowRef}
          width="60"
          height="60"
          viewBox="0 0 24 24"
          fill="none"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transformOrigin: "center center",
            pointerEvents: "none",
          }}
        >
          <path
            d="M12 2 L12 22 M12 22 L6 16 M12 22 L18 16"
            stroke="#00ffff"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            filter="drop-shadow(0 0 10px #00ffff)"
          />
        </svg>
      </section> */}
      {/* our process banner below text start */}
      <section className="seller-advice-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-9">
              <h1 className="main-heading text-center">
                Everything you need. Nothing you don't.
              </h1>
              <p className="text-center">
                Real estate can feel overwhelming—but
                <b> Milford Real Estate's </b>
                streamlined approach removes the guesswork. Follow along to see
                how we simplify the journey from listed to sold.
              </p>
              <div className="text-center next-text mt-2">NEXT</div>
            </div>
          </div>
        </div>
      </section>
      {/* our process banner below text end */}
      <div style={{ width: "100vw" }}>
        <img src={stepsgif} alt="" width="100%" height="" />
      </div>
      {/* what's next section start */}
      <section className="what-next-section">
        <img src={hutImg} alt="" className="hut-img-1" />
        <img src={hutImg1} alt="" className="hut-img-2" />
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="main-heading">What's Next?</h1>
              <p className="sub-content">
                Let's explore what comes next, whether you're purchasing your
                next home, investing in your future, or guiding someone else
                toward theirs.
              </p>
              <div className="btn-container">
                <button className="contact-us-btn"> LET'S CHAT </button>
                <button className="contact-us-btn">
                  {" "}
                  MAKE YOUR NEXT MOVE{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* what's next section end */}
      {/* Our process slider seciton start */}
      <section className="above-slider-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="rest-text">PROVEN RESULTS. PERSONALIZED SERVICE.</p>
              <h1 className="main-heading ">
                A Real Estate Experience Built Around You
              </h1>
            </div>
          </div>
        </div>
      </section>
      <div className="our-process-slider">
        <div className="container">
          <Slider {...settings}>
            <div className="card-container">
              <img src={ex1} alt="" className="img-fluid" />
              <div className="card-content">
                <p className="rest-text">Your Advantage in Any Market</p>
                <p>
                  You deserve more than uncertainty. At Milford Real Estate, we
                  turn market challenges into opportunities. Our team
                  anticipates trends and helps you navigate any conditions with
                  confidence — so you can buy or sell on your terms, with less
                  stress and better results.
                </p>
              </div>
            </div>
            <div className="card-container">
              <img src={ex2} alt="" className="img-fluid" />
              <div className="card-content">
                <p className="rest-text">Proven to Deliver More</p>
                <p>
                  Don't leave money on the table. Our results show it: we
                  consistently sell homes for more than comparable properties.
                  When you choose Milford Real Estate, you choose a team that
                  knows how to maximize your home's value and negotiate the best
                  outcome.
                </p>
              </div>
            </div>
            <div className="card-container">
              <img src={ex3} alt="" className="img-fluid" />
              <div className="card-content">
                <p className="rest-text">Your Goals. Our Promise.</p>
                <p>
                  You're not just another transaction. We believe in transparent
                  guidance, genuine relationships, and a client-first approach
                  that prioritizes your goals. In an industry where trust can be
                  rare, we work hard to earn yours — every step of the way.
                </p>
              </div>
            </div>
          </Slider>
        </div>
      </div>
      {/* Our process slider seciton start */}
      <Footer />
    </>
  );
}
